/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'es-ES'],
    /**
     * Note: When looking to support different i18n locales we'll have to decide
     * whether to support a subpath approach (and figure out how to change our CDN appropriately
     * for something like /en/checkout).
     *
     * OR
     *
     * Look at an alternative approach like query params, state, `Accept-Language` headers, etc.
     */
    localeDetection: false, // Turning of locale specific subpaths (e.g. /en/ or /es/) for now.
  },
}
